var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (
		(_vm.campaigns && _vm.campaigns.length) ||
			(_vm.location && _vm.location.type === 'dfp')
	)?_c('div',{staticClass:"sidearm-ad ad"},[(_vm.location && _vm.location.type)?_c(_vm.location.type,{tag:"component",attrs:{"name":_vm.name,"location":_vm.location,"campaigns":_vm.campaigns},on:{"set_width":_vm.emit_width}}):_vm._e()],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }